module.exports = __webpack_public_path__ + "static/img/img-features-feature-6-parents_cn.4439780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-6-parents_cn.png
// module id = PF9B
// module chunks = 18